import { render, staticRenderFns } from "./card.vue?vue&type=template&id=5230d39f&scoped=true&"
import script from "./card.js?vue&type=script&lang=js&"
export * from "./card.js?vue&type=script&lang=js&"
import style0 from "./card.scss?vue&type=style&index=0&id=5230d39f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5230d39f",
  null
  
)

export default component.exports